export default "__VITE_ASSET__CiFb0und__"